
import { useTaskSummaryMetricsSectionQuery } from 'generated/graphql';
import { DashMetricTypes } from 'modules/components/layer05/DashboardMetric/DashboardMetric';
import React from 'react';

type DashboardMetricDataType = {
  id: string;
  metricType: DashMetricTypes;
  count: number;
  title: string;
};

export interface IData {
  newTasks: DashboardMetricDataType;
  overdueTasks: DashboardMetricDataType;
  dueTasks: DashboardMetricDataType;
  completedTasks: DashboardMetricDataType;
}

export function useQuery(id: string) {
  const tuple = useTaskSummaryMetricsSectionQuery({
    variables: {
      id: id
    },
    skip: id === ''
  });


  return React.useMemo(
    () => {
      const newTasksCount = tuple.data?.project?.tasks.filter((rec) => rec.createdAt.diffNow().shiftTo('days').days <= 1).length ?? 0;
      const overdueTasksCount = tuple.data?.project?.overdueTasks.length ?? 0;
      const dueTasksCount = tuple.data?.project?.dueTasks.length ?? 0;
      const completedTasksCount = tuple.data?.project?.completedTasks.length ?? 0;
      const data: IData = {
        newTasks: __genDashboardMetric('newTasks', newTasksCount),
        overdueTasks: __genDashboardMetric('overdueTasks', overdueTasksCount),
        dueTasks: __genDashboardMetric('dueTasks', dueTasksCount),
        completedTasks: __genDashboardMetric('completedTasks', completedTasksCount)
      };



      return {
        ...tuple,
        data
      };
    },
    [tuple]
    // []
  );
}
function __genDashboardMetric(metricType: DashMetricTypes, count: number): DashboardMetricDataType {
  return {
    id: '',
    metricType: metricType,
    count: count,
    title: metricType
  };
}

